import { Component, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { map, flatMap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { FatTopBarSetup } from '../../../layout/fat-top-bar-layout/fat-top-bar-layout.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CompanysitesService } from '../company-sites.service';

@Component({
  selector: 'app-company-sites-layout',
  templateUrl: './company-sites-layout.component.html',
  styleUrls: ['./company-sites-layout.component.css']
})

export class CompanySitesLayoutComponent implements OnInit {

  layoutSetup: Observable<FatTopBarSetup>;

  constructor(private siteService: CompanysitesService) {
  }

  ngOnInit() {


  }

}
